// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__qlWCi","currentPage":"styles_currentPage__YI5g9","ellipsis":"styles_ellipsis__aPgy4"};